import {observer} from "mobx-react";
import {CONDITION_OPERATORS} from "../../../../../../../policy-types";
import {ICompareValueTypeComponentProps} from "../condition-field";
import DateCompareValueStore from "../../../../../../../stores/compare-value/date-compare-value-store";
import DateRangePickerV2, {DatePickerVariant, IDateRangeISO} from "../../../../../../../../../components/date-range-picker-v2/date-range-picker-v2";

const DateCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({
                                                                                       store,
                                                                                       condition,
                                                                                       operatorSelector
                                                                                   }) => {
    const compareValueStore = store as DateCompareValueStore;
    const datepickerVariant = (condition.operator === CONDITION_OPERATORS.OP_BETWEEN) ? DatePickerVariant.DATE_RANGE : DatePickerVariant.DATE;
    /** Parse ISO date range from store */
    const selectedDate = (): IDateRangeISO | undefined => {
        const from = compareValueStore.from;
        const to = compareValueStore.to;

        if (!from) {
            return undefined;
        }

        return {from, to};
    };

    /** Handle date selection from DateRangePickerV2 */
    const onDateSelected = (date: IDateRangeISO | null) => {
        if (!date?.from) {
            compareValueStore.setFrom(undefined);
            compareValueStore.setTo(undefined);
            return;
        }

        compareValueStore.setFrom(date.from);
        compareValueStore.setTo(date.to);
    };

    return (
        <>
            {operatorSelector}
            <DateRangePickerV2
                disabled={!condition.isEditMode}
                value={selectedDate()}
                variant={datepickerVariant}
                onChange={onDateSelected}
            />
        </>
    );
});

export default DateCompareValueField;